import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { User } from '../types/users.types';

interface DeleteConfirmationModalProps {
  visible: boolean;
  user: User | null;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  visible,
  user,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const footer = (
    <div className="flex justify-end space-x-3">
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onCancel}
        disabled={isLoading}
      />
      <Button
        label="Eliminar"
        icon="pi pi-trash"
        className="p-button-danger"
        onClick={onConfirm}
        loading={isLoading}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onCancel}
      header="Confirmar eliminación"
      footer={footer}
      className="w-96"
      modal
      closeOnEscape={!isLoading}
      closable={!isLoading}
      style={{ width: '28rem' }}
    >
      <div className="flex items-start space-x-4">
        <i className="pi pi-exclamation-triangle text-yellow-500 text-2xl mt-1"></i>
        <div className="flex-1">
          <p className="text-gray-700 mb-3 font-medium">
            ¿Estás seguro de querer eliminar este usuario?
          </p>
          {user && (
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-3">
              <p className="font-semibold text-gray-800">{user.email}</p>
              <p className="text-sm text-gray-600 mt-1">Código de usuario: {user.userCode}</p>
            </div>
          )}
          <p className="text-sm text-red-600 font-medium">
            Esta acción no se puede deshacer.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModal; 